module.exports = __webpack_public_path__ + "img/desktop-eyecatcher.276c2a06.png";